import { useEffect } from 'react';

import { scrollToNode } from '../utils/dom';
import { SCROLL_TIMEOUT } from '../utils/variables';
import { getSectionId } from '../utils/getters';

export const useHash = (elements = [], setSelectedElement) => {
  useEffect(() => {
    const { hash } = location;

    const handleSelectElementThenScroll = () => {
      if (elements) {
        const element = elements.find((e) => hash.includes(getSectionId(e)));
        setSelectedElement && element ? setSelectedElement(element) : null;
      }
      scrollToNode(hash);
    };

    if (hash) {
      const timer = setTimeout(() => {
        handleSelectElementThenScroll();
      }, SCROLL_TIMEOUT);
      return () => clearTimeout(timer);
    }
  }, []);
  return;
};
